import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginForm from '@/components/Forms/LoginForm';
import { APP_LINKS } from '@/helpers/links';
import { useUserStore } from '@/store/userStore';
import { useLoginUser } from '@/query/queries/user/useLoginUser';
import './index.scss';

const SignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutateAsync: loginUser } = useLoginUser()
  const accessToken = useUserStore(state => state.accessToken);
  const [loginError, setLoginError] = useState(null);

  useEffect(() => {
    if (accessToken) {
      const from = location.state?.from;
      const target = from?.pathname ? `${from.pathname}${from.search || ''}` : APP_LINKS.dashboard;
      navigate(target, { replace: true });
    }
  }, [accessToken, navigate, location.state]);

  const onSubmit = async values => {
    setLoginError(null);
    const payload = {
      email: values.email,
      password: values.password,
    };
    const res = await loginUser(payload);
    setLoginError(res?.message || '');
  };

  return (
    <div className="sign-in">
      <div className="sign-in__inner">
        <LoginForm onSubmit={onSubmit} error={loginError} />
      </div>
    </div>
  );
};

export default SignIn;
